import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TimesheetsPage } from '@/features/workforce/timesheets-page';

const searchSchema = z.object({
  week: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/workforce/timesheets')({
  validateSearch: searchSchema,
  component: TimesheetsRoute,
});

function TimesheetsRoute() {
  const { projectId } = Route.useParams();
  const { week } = Route.useSearch();
  return <TimesheetsPage projectId={projectId} week={week} />;
}
